"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRandomStringId = void 0;
const uuid_1 = require("uuid");
const generateRandomStringId = (amount) => {
    if (amount < 1 || amount > 32) {
        throw new Error(`Amount must be between 1 and 32, received amount: ${amount}`);
    }
    const uuidString = uuid_1.v4();
    const uuidWithoutHyphens = uuidString.replaceAll("-", "");
    return uuidWithoutHyphens.slice(0, amount);
};
exports.generateRandomStringId = generateRandomStringId;
//# sourceMappingURL=index.js.map